import React from "react"

import { SelectOption } from "shared/types/Select"

import { useAdminTeamLeaveOverlayViewModel } from "./model/useAdminTeamLeaveOverlayViewModel"
import { AdminTeamLeaveFormData } from "./model/useTeamLeaveOverlayModel"
import { AdminTeamLeaveOverlayView } from "./ui/AdminTeamLeaveOverlayView"

export interface AdminTeamLeaveOverlayProps {
  teamMemberOptions: SelectOption<string>[]
  hasPendingInvites: boolean
  wasLastAdmin: boolean
  onSubmit: (data: AdminTeamLeaveFormData) => void
  onCancel: () => void
}

export const AdminTeamLeaveOverlay = React.memo(
  (props: AdminTeamLeaveOverlayProps) => {
    return (
      <AdminTeamLeaveOverlayView
        {...useAdminTeamLeaveOverlayViewModel(props)}
      />
    )
  }
)
